module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_60.a1d37be6.png";